import { Controller } from "stimulus"
import L from 'leaflet';

// Fix Leaflet default marker icons not loading with webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default class extends Controller {
  static targets = [ "map" ]

  connect() {
    const map = this.loadMap()

    var markers = this.mapTarget.dataset.markers
    var marker = this.mapTarget.dataset.marker

    if (marker != null) {
      this.setMarker(map)
    } else if (markers != null) {
      this.setLocationDot(map)
      this.setMarkers(map, markers)
    }
  }

  loadMap() {
    var baseCenter = [48.8534, 2.3488]
    const map = L.map(this.mapTarget).setView(baseCenter, 6)
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 19,
    }).addTo(map)
    return map
  }

  setMarker(map) {
    const marker = JSON.parse(this.mapTarget.dataset.marker)
    map.setView([marker.lat, marker.lng], 17)
    L.marker([marker.lat, marker.lng]).addTo(map)
  }

  setLocationDot(map) {
    if (this.mapTarget.dataset.dot) {
      const dot = JSON.parse(this.mapTarget.dataset.dot)
      L.circleMarker([dot.lat, dot.lng], {
        radius: 7,
        fillColor: '#00F',
        fillOpacity: 0.6,
        color: '#00A',
        opacity: 0.9,
        weight: 1,
      }).addTo(map)

      const radius = this.mapTarget.dataset.radius
      if (radius) {
        L.circle([dot.lat, dot.lng], {
          radius: JSON.parse(radius) * 1000,
          color: '#16C995',
          opacity: 0.8,
          weight: 2,
          fillColor: '#FFFFFF',
          fillOpacity: 0.1,
        }).addTo(map)
      }
    }
  }

  setMarkers(map, markers) {
    markers = JSON.parse(markers)
    const mapMarkersArray = []
    if (markers) {
      markers.forEach(marker => {
        var mapMarker = L.marker([parseFloat(marker.lat), parseFloat(marker.lng)], { pharmacyId: marker.id }).addTo(map)
        mapMarker.bindPopup(marker.infowindow)
        mapMarkersArray.push(mapMarker)
      });

      // open marker popup when hovering the corresponding card
      const cards = document.querySelectorAll(".index-card")
      cards.forEach(card => {
        var markerHover = mapMarkersArray.find(m => m.options.pharmacyId === parseInt(card.dataset.id))
        if (!markerHover) return
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
          // mobile: no hover
        }else{
          card.addEventListener("mouseenter", () => {
            markerHover.openPopup()
          });
          card.addEventListener("mouseleave", () => {
            markerHover.closePopup()
          });
        }
      });
    }
    if (markers.length > 0) {
      this.fitMap(map, markers)
    }
  }

  fitMap(map, markers) {
    var bounds = L.latLngBounds(markers.map(m => [m.lat, m.lng]))
    map.fitBounds(bounds)
  }
}
